import config from "src/config";
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { KSK1070_R01DetailDto, KSK1070_R01Dto, KSK1070_R01HeaderDto, KSK1070_R01LotDto } from "./Dto_KSK1070_R01";
import { WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";


const baseUrl = `${config.apiUrl}/KSK1070_R01`;

export interface KSK1070_R01ListParams {
	startDate?: string;
	endDate?: string;
	customCd?: string;
	listLength?: number;
}

const getParams = (params: KSK1070_R01ListParams) => {
	return {
		startDate: params.startDate || undefined,
		endDate: params.endDate || undefined,
		customCd: params.customCd || undefined,
		listLength: params.listLength || 0
	}
}

export const getKSK1070_R01List = async (option: string, params: KSK1070_R01ListParams, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<KSK1070_R01HeaderDto[]>>(url, { params: getParams({ ...params, listLength }) });
}

export const getKSK1070_R01AllCount = async (params: KSK1070_R01ListParams) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params)
    });
}

export const getKSK1070_R01One = async (wmsOrderNo: string) => {
	const url = `${baseUrl}/one/${wmsOrderNo}`;

	return await getData<ResponseDto<KSK1070_R01HeaderDto>>(url);
}

export const getKSK1070_R01TransportHeader = async (wmsOrderNo: string) => {
    const url = `${baseUrl}/transport/${wmsOrderNo}`;

    return await getData<ResponseDto<KSK1070_R01HeaderDto>>(url);
}

export const getKSK1070_R01DetailList = async (wmsOrderNo: string, warehouseCd: string) => {
	const url = `${baseUrl}/detail/${wmsOrderNo}/${warehouseCd}`;

	return await getData<ResponseDto<KSK1070_R01DetailDto[]>>(url);
}

export const getKSK1070_R01WmsTransport = async (wmsOrderNo: string) => {
	const url = `${baseUrl}/wmsTransport/${wmsOrderNo}`;

	return await getData<ResponseDto<WmsTransportHeaderDto>>(url);
}

export const getKSK1070_R01LotList = async (wmsOrderNo: string, warehouseCd: string, itemCd: string) => {
	const url = `${baseUrl}/lot`;

	return await getData<ResponseDto<KSK1070_R01LotDto[]>>(url, { params: { 
			transportNo : wmsOrderNo || undefined,
			warehouseCd : warehouseCd || undefined,
			itemCd : itemCd || undefined
		} 
	});
}

export const createKSK1070_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
}

export const postKSK1070_R01 = async (data: KSK1070_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<KSK1070_R01Dto, ResponseDto<KSK1070_R01Dto[]>>(url, data);
}

export const patchKSK1070_R01 = async (data: KSK1070_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<KSK1070_R01Dto, ResponseDto<KSK1070_R01Dto[]>>(url, data);
}

export const deleteKSK1070_R01 = async (wmsOrderNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			wmsOrderNo
		}
	});
}

export const downloadExcel_KSK1070_R01 = async (option: string, wmsOrderNo: string, warehouseCd: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			wmsOrderNo,
			warehouseCd
		}
	})
}
